<template>
	<ButtonIcon
		v-if="canOpenHelp"
		notext
		color="primary"
		icon="fa-solid fa-circle-question"
		icon-size="small"
		data-test="appBar__help-btn"
		:loading="loading"
		:tooltip="{ text: 'Hilfe öffnen', bottom: true }"
		@click="openHelp"
	/>
</template>

<script setup lang="ts">
import ButtonIcon from 'components/templates/Base/ButtonIcon.vue'
import { useHelpPortal } from '@/composables/useHelpPortal'

// AAR-1805. Die Beschriftung ist absichtlich deutsch fest verdrahtet, wie der
// Offline-Hinweis in der Toolbar daneben: die Hilfe selbst gibt es nur auf
// Deutsch, ein englischer Tooltip würde also auf deutsche Inhalte zeigen.
//
// Der Riegel sitzt hier im Button und nicht in der Toolbar: die Toolbar
// entscheidet nur über den Breakpoint (ab sm), die Rolle gehört zur Hilfe.
const { openHelp, loading, canOpenHelp } = useHelpPortal()
</script>
